<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7nEAIf/tc-custom/9781452108414.jpg?1721404776826" alt="This image is the cover for the book Poulet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Poulet
      </h1>
      <p class="bookDescription body article font2">
        <b>“The humble and incredibly versatile chicken gets its due in [this] compact but thorough handbook on all things bird” by the acclaimed cookbook author (Stan Sagner, <i>New York Daily News</i>).</b><br/><br/>Poulet is more than just a cookbook dedicated to chicken: it is an ode to this worldwide favorite. More than fifty thoughtful recipes cover the globe to breathe new life into the well-loved chicken supper.<br/><br/>Five chapters are organized by flavor profile—American, Bistro, Latin, East and South Asian, and North African/Mediterranean—to bring to the table wherever you live. Each recipe is organized into a set matching a main course of chicken with a complementary grain, salad, vegetable, or bread.<br/><br/>Author Cree LeFavour’s sophistication and humor, coupled with wine, cocktail, and beer suggestions, spark a new appreciation of a time-honored favorite.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cree LeFavour, France Ruffenach
      </h2>
      
      <p class="authorDescription body article">Cree LeFavour is a cookbook writer who grew up on a ranch in Idaho. Her books include The New Steak (2008). She lives with her two children, Penn and Harriet, and her husband, Dwight Garner, in Frenchtown New Jersey.France Ruffenach is a San Francisco-based photographer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e6723f82